/** @format */

import { memo } from 'react'
import { CopyBlock, ocean } from 'react-code-blocks'

import styles from 'dir/styles/courses.module.css'

export const _1 = memo(() => (
  <section className={styles.section}>
    <h2 className={styles.h2}>1 - Работа с REST API</h2>
    <p className={styles.description}>
      Допустим, уже есть дерево компонентов, которое имеет несколько уровней иерархии и необходимо получить коллекцию
      элементов от API. Какой именно компонент в иерархии должен отвечать за HTTP-запросы и хранение результата ответа?
      Если не используем библиотеку управления состоянием, то это зависит от трех критериев.{' '}
    </p>
    <ul className={styles.list}>
      <li className={styles.list__item}>Каким компонентам будут необходимы полученные данные?</li>
      <li className={styles.list__item}>Где будет рендерится индикатор загрузки пока выполянется HTTP-запрос?</li>
      <li className={styles.list__item}>Где будет рендерится сообщение в случае ошибки HTTP-запроса?</li>
    </ul>
    <p className={styles.description}>
      Методы жизненного цикла <code className={styles.code}>componentDidMount</code> и{' '}
      <code className={styles.code}>componentDidUpdate</code> идеально подходят для HTTP-запросов. Когда вызывается{' '}
      <code className={styles.code}>componentDidMount()</code>, компонент уже был отрендерен в DOM и готов к
      последующему обновлению состояния. Когда вызывается <code className={styles.code}>componentDidUpdate()</code>,
      пропы или состояние компонента изменились, и, возможно, необходимо сделать новый запрос, предварительно сравнив
      их, чтобы не зациклить рендер компонента.{' '}
    </p>
    <p className={styles.description}>
      Для HTTP-запроса можно использовать что угодно: <code className={styles.code}>XMLHTTPRequest</code>,{' '}
      <code className={styles.code}>fetch</code>,<code className={styles.code}>axios</code>,{' '}
      <code className={styles.code}>superagent</code> и т. п. Мы будем использовать библиотеку{' '}
      <a className={styles.link} href="https://github.com/axios/axios#axios" target="_blank" rel="noopener noreferrer">
        axios
      </a>
      .
    </p>
    <CopyBlock text={`npm install axios`} language="javascript" showLineNumbers={false} theme={ocean} />
    <p className={styles.description}>
      Запросы будем делать на{' '}
      <a className={styles.link} href="https://hn.algolia.com/api" target="_blank" rel="noopener noreferrer">
        Hacker News API
      </a>
      . По завершению HTTP-запроса сохраняем результат в состоянии компонента. В методе{' '}
      <code className={styles.code}>render</code> используем состояние.
    </p>
    <CopyBlock
      text={`import React, { Component } from 'react';
import axios from 'axios';

const ArticleList = ({ articles }) => (
  <ul>
    {articles.map(({ objectID, url, title }) => (
      <li key={objectID}>
        <a href={url} target="_blank" rel="noreferrer noopener">
          {title}
        </a>
      </li>
    ))}
  </ul>
);

class App extends Component {
  state = {
    articles: [],
  };

  componentDidMount() {
    axios
      .get('https://hn.algolia.com/api/v1/search?query=react')
      .then(response => this.setState({ articles: response.data.hits }));
  }

  render() {
    const { articles } = this.state;

    return articles.length > 0 ? <ArticleList articles={articles} /> : null;
  }
}
`}
      language="javascript"
      showLineNumbers={false}
      theme={ocean}
    />
    <p className={styles.description}>
      Кроме свойства хранения данных, можно добавить свйоство для хранения флага индикатора загрузки и ошибки. Это
      позволит сделать использование интерфейса приятнее для пользователя.{' '}
    </p>
  </section>
))
